module.exports = __webpack_public_path__ + "static/media/backIcon.7b0e3039.svg";